module.exports = __webpack_public_path__ + "img/V-R-246-unload-standup-base.91981b1f.png";